<template>
  <v-dialog v-if="purpose" persistent v-model="tippaniVerificationModel" width="700">
    <v-card>
      <v-card-title class="headline blue darken-3 white--text" default-title>
        {{ kebabToNormalCase(purpose) }} Request
      </v-card-title>

      <v-card-text class="px-2 py-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <form-error-display-handler :errors="errors"/>
            <v-flex xs12>
              <div v-html="print_tippani_content"></div>
            </v-flex>
            <v-flex xs12>
              <v-form ref="tippaniVerificationForm" v-model="valid" lazy-validation>
                <v-textarea
                    label="Remarks *"
                    :rules="[rules.required]"
                    outlined
                    rows="3"
                    v-model="tippaniVerificationForm.remarks"
                />
                <!--                <multiple-file-upload-->
                <!--                    label="Upload documents (if any)"-->
                <!--                    v-model="tippaniVerificationForm.files"-->
                <!--                />-->
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="red lighten-1" class="white--text" @click="closeModal">Close</v-btn>
        <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="save">
          {{ purpose === 'approve-tippani' ? 'Approve' : 'Verify' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
import {validationMixin} from "../../mixins/validationMixin";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import FileInput from "../FileInput";
import MultipleFileUpload from "../MultipleFileUpload";

export default {
  data: () => ({
    valid: true,
    tippaniVerificationForm: {},
    errors: [],
    loading: false
  }),
  components: {
    FormErrorDisplayHandler,
    FileInput,
    MultipleFileUpload
  },
  mixins: [validationMixin],
  computed: {
    purpose() {
      return this.$store.state.TrekkingSingle.forwardPurpose
    },
    tippaniVerificationModel: {
      get() {
        return this.$store.state.TrekkingSingle.tippaniVerificationModel;
      },
      set(value) {
        this.$store.commit("TrekkingSingle/setTippaniVerificationModal", value);
      }
    },
    print_tippani_content() {
      let trekkingData = this.$store.state.TrekkingSingle.trekkingData;
      if(trekkingData) {
        const tippani = trekkingData.tracks.find((i) => i.statusNumber === 10)
        if (tippani) {
          return tippani.content.content
        }
      }
      return null;
    },
  },
  methods: {
    ...mapActions("TrekkingSingle", ["verifyTippaniGenerated", "approveTippani"]),
    kebabToNormalCase(str) {
      return str
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
    },
    save() {
      if (this.$refs.tippaniVerificationForm.validate()) {
        let formData = new FormData();
        formData.set('remarks', this.tippaniVerificationForm.remarks);
        let files = this.tippaniVerificationForm.files;
        if (files !== undefined) {
          for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i]);
          }
        }

        switch (this.purpose) {
          case 'verify-tippani':
            this.verifyTippaniRequest(formData);
            break;
          case 'approve-tippani':
            this.approveTippaniRequest(formData);
            break;
        }
      }
    },
    approveTippaniRequest(data) {
      this.approveTippani(data).then(r => {
        this.closeModal();
        this.$emit('purposeCompleted', this.purpose)
      })
    },
    verifyTippaniRequest(data) {
      this.verifyTippaniGenerated(data).then(r => {
        this.closeModal();
        this.$emit('purposeCompleted', this.purpose)
      })
    },
    closeModal() {
      this.tippaniVerificationForm = {}
      this.errors = null
      this.tippaniVerificationModel = false;
    }
  }
};
</script>
